<template>
  <div class="tp-hover-tooltip">
    <div class="tp-hover-tooltip__header">Stand {{ title }}</div>
    <table class="tp-hover-tooltip__table" :class="{ 'tp-hover-tooltip__table--values-right': valuesRight }">
      <tbody>
        <tr v-for="(row, i) in rows" :key="i">
          <td class="tp-hover-tooltip__label">
            <span>{{ row.label }}</span>
          </td>
          <td v-if="row.html" class="tp-hover-tooltip__value" v-html="row.value"></td>
          <td v-else class="tp-hover-tooltip__value" :class="{ 'tp-hover-tooltip__value--bold': row.bold }">
            {{ row.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Erhält über `params.value` ein vom tooltipValueGetter gebautes Datenobjekt
// der Form { title, valuesRight, rows } und rendert daraus die Tooltip-Tabelle
export default {
  computed: {
    value() {
      return (this.params && this.params.value) || {};
    },
    title() {
      return this.value.title || '';
    },
    rows() {
      return Array.isArray(this.value.rows) ? this.value.rows : [];
    },
    valuesRight() {
      return this.value.valuesRight === true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tp-hover-tooltip {
  background: var(--surface);
  border: 0.8px solid var(--border);
  border-radius: 10px;
  box-shadow: 0px 3px 4px -2px #0000001a, 0px 20px 25px -1px #0000001a;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #4b4b4b;
  width: 240px;
  padding: 8px 16px;
  overflow: hidden;

  &__header {
    padding: 0 0 8px 0;
    font-weight: 600;
    border-bottom: 0.8px solid var(--border);
    background: transparent;
    text-align: center;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;

    td {
      padding: 8px 0;
      vertical-align: middle;
      line-height: 1.4;
    }
  }

  &__label {
    padding-right: 12px;
    background: transparent;
  }

  &__value {
    text-align: left;
    white-space: nowrap;

    &--bold {
      font-weight: 600;
    }
  }

  &__table--values-right .tp-hover-tooltip__value {
    text-align: right;
  }
}
</style>
